import React, { useEffect, useState } from "react";
import { Text, Flex, Table, Button, AlertDialog } from "@radix-ui/themes";
import { useNavigate } from "react-router-dom";
import { GeneralContextFunc } from "../Context/GeneralContex";
import { stopCampaign } from "../Services/DashboardApi";
import { useLocation } from "react-router-dom";

const FundingBox = ({ funding }) => {
  const location = useLocation();
  const { setloader, initAlert } = GeneralContextFunc();
  const navigate = useNavigate();
  const [Funding, setFunding] = useState({
    totalGoal: "",
    funding: [],
  });

  const stopBtn = () => {
    setloader(true);
    let payload = {
      id: location?.state?.id,
    };
    stopCampaign(payload)
      .then((res) => {
        setloader(false);
        initAlert(res?.message);
        navigate("/campaigns");
      })
      .catch((err) => {
        setloader(false);
        if (err.response.data.error === "jwt expired") {
          initAlert("Your session is expired", "info");
          navigate("/");
          return;
        }
        initAlert(err?.response?.data?.message ?? "Error", "error");
      });
  };

  useEffect(() => {
    setFunding(funding);
  }, [funding]);

  return (
    <div className="fundingBox">
      <div className="tableBox">
        <Flex justify="between">
          <Text weight="bold">Funding</Text>
          <Text weight="bold">Total:${Funding.totalGoal}</Text>
        </Flex>
        <Table.Root>
          <Table.Body>
            {Funding.funding.map((data, i) => (
              <Table.Row key={i}>
                <Table.RowHeaderCell>{data.name}</Table.RowHeaderCell>
                <Table.Cell>{data.location}</Table.Cell>
                <Table.Cell>$ {data.amount}</Table.Cell>
              </Table.Row>
            ))}
          </Table.Body>
        </Table.Root>
        <div
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "end",
            margin: "24px 0px",
          }}
        >
          <AlertDialog.Root>
            <AlertDialog.Trigger>
              <Button color="red" size="3" style={{ cursor: "pointer" }}>
                Stop
              </Button>
            </AlertDialog.Trigger>
            <AlertDialog.Content maxWidth="380px">
              <AlertDialog.Title>
                Are you sure you want to stop this ?
              </AlertDialog.Title>
              <Flex justify="end" gapX="4">
                <AlertDialog.Cancel>
                  <Button variant="outline">Cancel</Button>
                </AlertDialog.Cancel>
                <AlertDialog.Action>
                  <Button onClick={() => stopBtn()} color="red">
                    Stop Campaign
                  </Button>
                </AlertDialog.Action>
              </Flex>
            </AlertDialog.Content>
          </AlertDialog.Root>
        </div>
      </div>
    </div>
  );
};

export default FundingBox;
